export const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => Boolean(window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone);
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const urlB64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};
